import React from 'react';
import { Text, View } from 'react-native-web';
import { Image } from 'react-native';
import { img_credit_card_source } from '../../../../utils/ImagesManagementUtils';
import { Available_withdrawal } from '../../../../utils/DictionaryManagementUtils';

//= ========================================================================

const SourceCard = ({
  globJSON, isBlueBorder,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    card: {
      marginBottom: 10,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 4 : 9,
      borderColor: isBlueBorder ? colors.primary_cta_color : colors.border_light_color,
      borderWidth: 1.6,
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: 90,
      width: '100%',
      padding: 7,
    },
    text: {
      fontSize: 9.4,
      lineHeight: 10.8,
      fontFamily: 'Quicksand-Semibold',
    },
    image: {
      width: '40%',
      height: '66%',
      borderRadius: 2,
      marginRight: 7,
    },
  };

  return (
    <View style={myStyles.card}>
      <Image
        fadeDuration={0}
        style={myStyles.image}
        source={img_credit_card_source}
      />
      <Text style={myStyles.text}>{Available_withdrawal}</Text>
    </View>
  );
};
export default SourceCard;
